
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import * as ChartModuleMore from 'highcharts/highcharts-more.js';
import HCSoldGauge from 'highcharts/modules/solid-gauge';
import Highcharts from 'highcharts'
ChartModuleMore(Highcharts);
HCSoldGauge(Highcharts);

class Chart2 extends Component {
	constructor() {
		super();
		this.state = {
			data: null,
			level_chart_1: null,
			cerrent_quarter: null,
			cerrent_area: null
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		if (this.props.dealerTypeChart) {
			var data_sent = {
				level_chart_1: this.props.level_chart_1,
				cerrent_quarter: this.props.cerrent_quarter,
				dealer_code: this.props.selected_dealer
			}
			APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS4_BYDEALER, data_sent, ({ datas }) => {
				this.setState({
					data: datas
				}, () => {
					Alert.LoadingClose()
					this.seDataChart(datas)
				})
			})
		}
	}
	componentWillUpdate(nextProps, nextState) {
		if (!this.props.dealerTypeChart) {
			if (nextProps.level_chart_1 && nextProps.level_chart_1 !== nextState.level_chart_1) {
				this.setState({
					level_chart_1: nextProps.level_chart_1,
					cerrent_quarter: nextProps.cerrent_quarter,
					cerrent_area: nextProps.cerrent_area,
				}, () => {
					var data_sent = {
						level_chart_1: this.state.level_chart_1,
						cerrent_quarter: this.state.cerrent_quarter,
						cerrent_area: this.state.cerrent_area
					}
					APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS4, data_sent, ({ datas }) => {
						this.setState({
							data: datas
						}, () => {
							Alert.LoadingClose()
							this.seDataChart(datas)
						})
					})
				})
			}
		}
	}
	seDataChart(datas) {
		var categories = [
			"Service Initiation",
			"Service Advisor",
			"Service Facility",
			"Service Pickup",
			"Service Quality",
			"Follow-up after repair",
			"AVG Q1-Q10"
		]
		var _data = {
		}
		if (this.props.dealerTypeChart || (this.state.level_chart_1 == 1 || this.state.level_chart_1 == 2)) {
			datas.map((row) => {
				var a = _data["val_set_qtr" + row.quarter_number] = []
				a.push(parseFloat((row.sv1.avg).toFixed(2)))
				categories[0] += " ( N:" + row.sv1.count + " )"
				a.push(parseFloat((row.sv2.avg).toFixed(2)))
				categories[1] += " ( N:" + row.sv2.count + " )"
				a.push(parseFloat((row.sv3.avg).toFixed(2)))
				categories[2] += " ( N:" + row.sv3.count + " )"
				a.push(parseFloat((row.sv4.avg).toFixed(2)))
				categories[3] += " ( N:" + row.sv4.count + " )"
				a.push(parseFloat((row.sv5.avg).toFixed(2)))
				categories[4] += " ( N:" + row.sv5.count + " )"
				a.push(parseFloat((row.sv6.avg).toFixed(2)))
				categories[5] += " ( N:" + row.sv6.count + " )"
				a.push(parseFloat((row.avg_q1_to_q10.avg).toFixed(2)))
				categories[6] += " ( N:" + row.avg_q1_to_q10.count + " )"
			})
		} else if (this.state.level_chart_1 == 3) {
			datas.map((row) => {
				var a = _data["val_set_qtr" + row.quarter_number] = []
				a.push(parseFloat((row.avgd_summary_data_by_area[this.state.cerrent_area].sv1.avg).toFixed(2)))
				categories[0] += " ( N:" + row.avgd_summary_data_by_area[this.state.cerrent_area].sv1.count + " )"
				a.push(parseFloat((row.avgd_summary_data_by_area[this.state.cerrent_area].sv2.avg).toFixed(2)))
				categories[1] += " ( N:" + row.avgd_summary_data_by_area[this.state.cerrent_area].sv2.count + " )"
				a.push(parseFloat((row.avgd_summary_data_by_area[this.state.cerrent_area].sv3.avg).toFixed(2)))
				categories[2] += " ( N:" + row.avgd_summary_data_by_area[this.state.cerrent_area].sv3.count + " )"
				a.push(parseFloat((row.avgd_summary_data_by_area[this.state.cerrent_area].sv4.avg).toFixed(2)))
				categories[3] += " ( N:" + row.avgd_summary_data_by_area[this.state.cerrent_area].sv4.count + " )"
				a.push(parseFloat((row.avgd_summary_data_by_area[this.state.cerrent_area].sv5.avg).toFixed(2)))
				categories[4] += " ( N:" + row.avgd_summary_data_by_area[this.state.cerrent_area].sv5.count + " )"
				a.push(parseFloat((row.avgd_summary_data_by_area[this.state.cerrent_area].sv6.avg).toFixed(2)))
				categories[5] += " ( N:" + row.avgd_summary_data_by_area[this.state.cerrent_area].sv6.count + " )"
				a.push(parseFloat((row.avgd_summary_data_by_area[this.state.cerrent_area].avg_q1_to_q10.avg).toFixed(2)))
				categories[6] += " ( N:" + row.avgd_summary_data_by_area[this.state.cerrent_area].avg_q1_to_q10.count + " )"
			})
		}

		console.log(_data)
		var series = []
		if (this.props.dealerTypeChart || (_data.val_set_qtr2 && this.state.level_chart_1 == 1) || (this.state.level_chart_1 == 2 && this.state.cerrent_quarter == 2) || this.state.level_chart_1 == 3) series.push({
			name: 'Quarter 2/21',
			data: _data.val_set_qtr2
		})
		if (this.props.dealerTypeChart || _data.val_set_qtr3) {
			series.push({
				name: 'Quarter 3/21',
				data: _data.val_set_qtr3
			})
		} else if (this.state.level_chart_1 == 1 || (this.state.level_chart_1 == 2 && this.state.cerrent_quarter == 3)) {
			series.push({
				name: 'Quarter 3/21',
				data: [0, 0, 0, 0, 0, 0, 0]
			})
		}
		if (this.props.dealerTypeChart || _data.val_set_qtr4) {
			series.push({
				name: 'Quarter 4/22',
				data: _data.val_set_qtr4
			})
		} else if (this.state.level_chart_1 == 1 || (this.state.level_chart_1 == 2 && this.state.cerrent_quarter == 4)) {
			series.push({
				name: 'Quarter 4/22',
				data: [0, 0, 0, 0, 0, 0, 0]
			})
		}
		if (this.props.dealerTypeChart || _data.val_set_qtr1) {
			series.push({
				name: 'Quarter 1/22',
				data: _data.val_set_qtr1
			})
		} else if (this.state.level_chart_1 == 1 || (this.state.level_chart_1 == 2 && this.state.cerrent_quarter == 1)) {
			series.push({
				name: 'Quarter 1/22',
				data: [0, 0, 0, 0, 0, 0, 0]
			})
		}
		Highcharts.chart('chart_2_2', {

			title: {
				text: (this.props.dealerTypeChart ? "AVG by Factors" : 'AVG by Dimension')
			},

			subtitle: {
				text: ''
			},

			yAxis: {
				title: {
					text: ''
				}
			},

			xAxis: {
				// accessibility: {
				// 	rangeDescription: 'Range: 2010 to 2017'
				// },
				categories: categories
			},

			legend: {
				layout: 'vertical',
				align: 'right',
				verticalAlign: 'middle'
			},

			plotOptions: {
				series: {
					label: {
						connectorAllowed: false
					},
					// pointStart: 2010,
					// point: {
					// 	events: {
					// 		click: (e) => this.handleClickChart(e, {}, {})
					// 	}
					// }
				},
				line: {
					dataLabels: {
						enabled: true
					},
					enableMouseTracking: true
				}
			},
			series: series,

			responsive: {
				rules: [{
					condition: {
						maxWidth: 500
					},
					chartOptions: {
						legend: {
							layout: 'horizontal',
							align: 'center',
							verticalAlign: 'bottom'
						}
					}
				}]
			}
		});
	}
	render() {
		return (
			<div className={"chart-box"}>
				<center>
					<div id="chart_2_2" style={{ width: "94%", height: "450px" }}></div>
				</center>
			</div>
		);
	}
}

export default Chart2;